import React, { useEffect, useState } from "react";
import moment from "moment";
import swal from "sweetalert2";
import MatchPlayList from "./matchPlayList";
import { useHistory } from "react-router-dom";

import {
    getMatchPlayRound,
    postMatchPlayRound,
} from "../api/matchPlayAPI";

const MatchPlayRound = (props) => {

    const [refetchData, setRefetchData]  = useState(false);
    const [mMaster, setMMaster] = useState(null);
    const [pageData, setPageData] = useState({});
    const [rounds, setRounds] = useState([]);
    const [totalPlayers, setTotalPlayers] = useState(0);
    const [matchPlayID, setMatchPlayID] = useState();
    const history = useHistory();

    //#region Effects
    useEffect(() => {
        props.title("Round Deadline", "matchplay-round");
        // Opened from Quick Action as /matchplay-round/:id → open that match play
        const mID = history.location.pathname.split('/').find(p => !isNaN(p) && p !== '');
        setMatchPlayID(mID);
    }, []);

    useEffect(() => {
        if (rounds.length === 0) return;
        $(".date-input").each(function(index) {
            $(this)
                .datepicker({
                    format: "yyyy-mm-dd"
                })
                .off("changeDate")
                .on("changeDate", function(e) {
                    onChangeRoundDate(
                        index,
                        moment(e.date).format("YYYY-MM-DD")
                    );
                });
        });
    }, [rounds.length]);

    const closeDrawer = () =>{
        // window.removeCkeditor("editorContent");
        Config.Core.CloseDrawer();
    }
    //#endregion

    //#region API Calls
    const fetchMatchPlayRound = async (matchPlayId) => {
        try {
            swal.fire({
                titleText: "Loading",
                text: "Please Wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: () => swal.showLoading(),
            });
            const res = await getMatchPlayRound(matchPlayId);
            swal.close();
            if (res?.length == 0) return;
            setPageData(res);
            const { MatchPlay, MatchPlayPlayers, MatchPlayRegister, MatchPlayRound, action } = res;

            // Registration open validation
            if (moment(MatchPlay.CloseDate).isAfter(moment())) {
                swal.fire({
                    icon: "warning",
                    titleText: "Oops..",
                    text: "Registration is still open for this match play.",
                });
                return;
            }

            const total =
                action === "a"
                    ? MatchPlayRegister.length
                    : (MatchPlayPlayers?.length || 0) === 0
                        ? MatchPlayRegister.length
                        : MatchPlayPlayers.length;

            setTotalPlayers(total);
            if (total === 0) {
                swal.fire({
                    icon: "warning",
                    titleText: "Oops..",
                    text: "No players registered for this match play.",
                });
                return;
            }

            // Calculate rounds
            let goodTotal = 1;
            let totalRounds = 0;

            while (goodTotal < total) {
                goodTotal *= 2;
                totalRounds++;
            }

            let roundList = [];

            for (let i = 1; i <= totalRounds; i++) {
                let roundName = "";
                if (i === (totalRounds - 2)) {
                    roundName = "Quarter Final";
                }
                else if (i === (totalRounds - 1)) {
                    roundName = "Semi Final";
                }
                else if (i === totalRounds) {
                    roundName = "Final";
                }
                else {
                    roundName = `Round ${i}`;
                }
                const existingRound = MatchPlayRound?.find(r => r.Round === i);
                roundList.push({
                    ID: existingRound?.ID || 0,
                    MatchPlayID: MatchPlay.ID,
                    Round: i,
                    Name: roundName,
                    EndDate: existingRound?.EndDate
                        ? moment(existingRound.EndDate).format("YYYY-MM-DD")
                        : "",
                });
            }
            setRounds(roundList);
        } catch (err) {
            swal.fire({
                icon: "error",
                titleText: err.message,
            });
        }
    };

    const saveRoundDeadline = async () => {

        try {
            // Validation
            for (let i = 0; i < rounds.length; i++) {
                if (!rounds[i].EndDate) {
                    swal.fire({
                        icon: "warning",
                        titleText: "Oops..",
                        text: `${rounds[i].Name} end date is required.`,
                    });
                    return;
                }
            }

            // Round date validation
            for (let i = 1; i < rounds.length; i++) {
                const previous = rounds[i - 1];
                const current = rounds[i];
                if (moment(current.EndDate).isBefore(moment(previous.EndDate))) {
                    swal.fire({
                        icon: "warning",
                        titleText: "Oops..",
                        text: `${current.Name} end date should be greater than ${previous.Name} end date.`,
                    });
                    return;
                }
            }

            // Final validation
            const lastRound = rounds[rounds.length - 1];

            if (moment(lastRound.EndDate).isAfter(moment(mMaster.EndDate))) {
                swal.fire({
                    icon: "warning",
                    titleText: "Oops..",
                    text: `Final round end date should be lesser than ${mMaster.Name} end date.`,
                });
                return;
            }

            swal.fire({
                titleText: "Loading",
                text: "Please Wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                onOpen: () => swal.showLoading(),
            });

            const payload = {
                matchPlayId: mMaster.ID,
                matchPlayRound: rounds.map(r => ({
                    ...r,
                    EndDate: moment(r.EndDate).format("YYYY-MM-DD"),
                })),
            };

            await postMatchPlayRound(payload);

            swal.fire({
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 1500,
                animation: false,
                showConfirmButton: false,
                customClass: {
                    popup: "margin-20",
                },
                titleText: "Match play round updated successfully!",
            });

            fetchMatchPlayRound(mMaster.ID);
            setRefetchData(true);
        } catch (err) {
            swal.fire({
                icon: "error",
                titleText: err.message,
            });
        }
    };

    //#endregion

    //#region Handlers

    const onSelectHandler = async (master) => {
        if (!master) return;
        setMMaster(master);
        await fetchMatchPlayRound(master.ID);
    };

    const onChangeRoundDate = (index, value) => {
        setRounds(prev => {
            const updated = [...prev];
            updated[index].EndDate = value;
            return updated;
        });
    };

    const onReset = () => {
        setMMaster(null);
        setPageData({});
        setRounds([]);
        setTotalPlayers(0);
    };

    //#endregion

    return (
        <>
            <MatchPlayList
                matchPlayID={matchPlayID}
                setMatchPlayID={setMatchPlayID}
                title={"Round Deadline"}
                comp={"round"}
                refetchData={refetchData}
                resetRefetch={() => setRefetchData(false)}
                onSelectHandler={onSelectHandler}
                resetData={onReset}
            >
                <div className="kt-portlet round-deadline-modal">
                    <div className="kt-portlet__body padding-t10 padding-b20">
                        {!!mMaster && (
                            <div
                                className="kt-notification margin-t10 mb-3 margin-lr20 bg-lightGrey"
                            >
                                <div className="kt-notification__item d-block">
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="kt-user-card-v2 mb-2">
                                                <div className="kt-user-card-v2__pic">
                                                    <img
                                                        src={mMaster.Icon}
                                                        alt="matchPlay-logo"
                                                    />
                                                </div>
                                                <div className="kt-user-card-v2__details">
                                                    <span className="kt-user-card-v2__name text-clip">
                                                        {mMaster.Name}
                                                    </span>
                                                    <span className="kt-user-card-v2__desc">
                                                        {mMaster.Type} | {mMaster.MembershipType}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2 d-flex-center">
                                            <div className="kt-user-card-v2 mb-2">
                                                <div className="kt-user-card-v2__details">
                                                    <span className="kt-user-card-v2__name">
                                                        Start
                                                    </span>
                                                    <span className="kt-user-card-v2__desc">
                                                        {moment(mMaster.StartDate).format("DD-MMM-YYYY")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-2 d-flex-center">
                                            <div className="kt-user-card-v2 mb-2">
                                                <div className="kt-user-card-v2__details">
                                                    <span className="kt-user-card-v2__name">
                                                        End
                                                    </span>
                                                    <span className="kt-user-card-v2__desc">
                                                        {moment(mMaster.EndDate).format("DD-MMM-YYYY")}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!!mMaster && rounds.length > 0 && (
                            <div className="kt-portlet margin-lr20">
                                <div className="kt-portlet__body">
                                    {/* <div className="alert alert-light">
                                        Total Players : <b>{totalPlayers}</b>
                                    </div> */}
                                    {rounds.map((round, index) => (
                                        <div
                                            className="form-group row"
                                            key={round.Round}
                                        >
                                            <label className="col-form-label col-lg-3">
                                                {round.Name}
                                                <span className="red"> *</span>
                                            </label>
                                            <div className="col-xl-6 col-lg-8">
                                                <div className="input-group date">
                                                    <input
                                                        type="text"
                                                        readOnly={true}
                                                        className="form-control date-input"
                                                        placeholder="YYYY-MM-DD"
                                                        value={round.EndDate || ""}
                                                        onChange={({ target }) =>
                                                        onChangeRoundDate(index, target.value)
                                                    }
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text"> <i className="la la-calendar-check-o"></i> </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="kt-portlet__foot">
                                    <div className="kt-form__actions">
                                        <button
                                            type="button"
                                            className="btn btn-brand padding-lr50"
                                            onClick={saveRoundDeadline}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </MatchPlayList>
        </>
    );
};

export default MatchPlayRound;